var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { Icon } from "../Icon";
import Spinner from "../Spinner/Spinner";
import "./button.scss";
const defaultProps = {
    "data-testid": "tecma-button",
    size: "medium",
    color: "primary",
    fluid: false,
    disabled: false,
    outlined: false,
    rightIcon: false,
    iconName: undefined,
    loader: undefined,
    iconSize: undefined,
    link: false,
    rounded: false,
};
/**
 * A button is a clickable element used to perform an action. It contains a text label and a supporting icon can be displayed.
 */
const Button = React.forwardRef((_a, ref) => {
    var { onClick, rounded, disabled, color, outlined, children, iconName, loader, rightIcon, size, fluid, iconSize, link, className } = _a, rest = __rest(_a, ["onClick", "rounded", "disabled", "color", "outlined", "children", "iconName", "loader", "rightIcon", "size", "fluid", "iconSize", "link", "className"]);
    const classList = classNames("tecma-button", { rounded }, { disabled }, { outlined }, { fluid }, { link }, { [`${color}`]: color }, { "icon-on-right": rightIcon }, { [`${size}`]: size }, { "icon-only": !children && iconName }, className);
    return (_jsxs("button", Object.assign({ type: "button", onClick: onClick, className: classList, disabled: disabled }, rest, { ref: ref, children: [iconName && _jsx(Icon, { "aria-label": iconName, iconName: iconName, size: iconSize }), loader && _jsx(Spinner, { type: loader }), children] })));
});
Button.defaultProps = defaultProps;
export default Button;
